var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 68,
    viewBox: "0 0 62 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5961 28.4347H5.58798C2.50623 28.4347 0.00878906 30.9313 0.00878906 34.0131V61.9098C0.00878906 64.9916 2.50623 67.4906 5.58798 67.4906H42.5961C45.6778 67.4906 48.1769 64.9916 48.1769 61.9098V34.0123C48.1769 30.9313 45.6778 28.4347 42.5961 28.4347ZM20.9081 56.7384C18.2415 58.2779 14.9082 56.3534 14.9082 53.2742V42.8384C14.9082 39.7592 18.2415 37.8347 20.9081 39.3742L29.9461 44.5922C32.6128 46.1318 32.6128 49.9808 29.9461 51.5204L20.9081 56.7384Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3513 45.5871C21.4511 44.4898 19.0757 45.8611 19.0757 48.0554V48.0554C19.0757 50.2495 21.4509 51.6208 23.3511 50.5237V50.5237C25.2511 49.4267 25.2512 46.6843 23.3513 45.5871V45.5871Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6865 56.4513C49.6865 57.7887 50.3549 59.0377 51.4677 59.7795L51.5747 59.8508C54.2329 61.623 57.7935 59.7174 57.7935 56.5226V39.4031C57.7935 36.2082 54.2326 34.3027 51.5744 36.0751L51.4675 36.1464C50.3548 36.8883 49.6865 38.1371 49.6865 39.4744V56.4513Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2228 33.7308C61.2228 32.1683 59.4229 33.1951 59.4229 34.7577V61.1668C59.4229 62.7297 61.2228 63.7565 61.2228 62.1935V62.1935V33.7308V33.7308Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8158 26.8645C16.0218 26.8645 20.242 22.6442 20.242 17.4383C20.242 12.2323 16.0218 8.01205 10.8158 8.01205C5.6099 8.01205 1.38965 12.2323 1.38965 17.4383C1.38965 22.6442 5.6099 26.8645 10.8158 26.8645Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0769 0.00234985C27.6579 0.00234985 21.645 6.01598 21.645 13.435C21.645 20.85 27.6579 26.866 35.0769 26.866C42.4951 26.866 48.5079 20.8508 48.5079 13.435C48.5071 6.01678 42.4943 0.00234985 35.0769 0.00234985Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCamera);
export default __webpack_public_path__ + "static/media/video-camera.4f7bb2699de6b333b45d7408a121fdcb.svg";
export { ForwardRef as ReactComponent };